import Cookie from 'js-cookie';
import PermissionProvider from './module/PermissionProvider/PermissionProvider';
import React, { useEffect, useRef, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import './App.scss';
import { RouterConfig } from './components/V2/const/routerConfig';
import PublicDesktopLayout from './components/V2/Layout/Desktop/PublicDesktopLayout/PublicDesktopLayout';
import PublicMobileLayout from './components/V2/Layout/Mobile/PublicMobileLayout/PublicMobileLayout';
import { actionLogout } from './features/system/actions';
import { store } from './index';
import * as constants from './utils/constants/constant';
import { isMobileAndTabletCheck } from './utils/helpers/helpers';

const isViewFullPage = (pathname) => {
  return (
    pathname === constants.routes.LOGIN ||
    pathname === constants.routes.FORGOT_PASSWORD
  );
};

const Logout = () => {
  store.dispatch(actionLogout());
  return <Redirect to='/home' />;
};

const Routes = (props) => {
  const [Update, setUpdate] = useState(Date.now());
  //?----------- check screen type mobile|desktop ------------//
  const isMobileDisplay = useRef(isMobileAndTabletCheck());
  const isMobile = isMobileAndTabletCheck();

  // const checkDisplayType = useCallback(() => {
  //   const newValue = isMobileAndTabletCheck();
  //   if (isMobile !== newValue) {
  //     isMobileDisplay.current = newValue;
  //     // window.location.reload();
  //     setUpdate(Date.now());
  //   }
  // }, [isMobile]);

  useEffect(() => {
    function check() {
      // setTimeout(checkDisplayType, 0);
      setUpdate(Date.now());
      setTimeout(() => setUpdate(Date.now()), 0);
    }
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('resize', check);
    };
  }, []);

  return (
    <Switch>
      {/* <Route exact path='/logout' component={Logout} />
        <PublicRoute exact path='/' component={Home} />
      /> */}
      {RouterConfig.map((r) => {
        const { component, needAuthor, grantPermision, ...rest } = r;
        const mode = isMobileAndTabletCheck() ? 'mobile' : 'desktop';

        const Component =
          r?.component?.[mode]?.page || r?.component?.[mode] || r?.component;
        const PublicLayout = isMobileAndTabletCheck()
          ? PublicMobileLayout
          : PublicDesktopLayout;
        const Layout =
          r?.component?.[mode]?.layout || r?.['layout'] || PublicLayout;
        const loggedIn = isAuthenticate();
        console.log('needAuthor', needAuthor);

        return (
          <Route key={r.path} exact {...rest}>
            <Layout>
              {/* {!needAuthor || (needAuthor && loggedIn) ? ( */}
              <PermissionProvider {...r}>
                <Component {...rest} mode={mode} />
              </PermissionProvider>
              {/* ) : (
                <Redirect
                  to={{
                    pathname: constants.routes.HOME,
                    state: { from: props.location },
                  }}
                />
              )} */}
            </Layout>
          </Route>
        );
      })}
    </Switch>
  );
};

export default Routes;

// const PrivateRoute = (props) => {
//   const { component: Component, passProps, ...rest } = props;
//   const loggedIn = isAuthenticate();
//   return (
//     <Route
//       {...rest}
//       render={(props) => {
//         const { role } = store.getState().systemReducer;
//         if (!loggedIn) {
//           return (
//             <Redirect
//               to={{
//                 pathname: constants.routes.HOME,
//                 state: { from: props.location },
//               }}
//             />
//           );
//         }
//         if (isRestrict(props.location.pathname, role))
//           return (
//             <Redirect to={{ pathname: '/', state: { from: props.location } }} />
//           );

//         return (
//           <>
//             <Header />
//             {/* <div className="bgColor-bottomMenu"></div> */}
//             <Row>
//               <div className='container-content'>
//                 <Loading />
//                 {/* <SessionTimeOut /> */}
//                 <Component {...props} {...passProps} />
//               </div>
//             </Row>
//             <Footer />
//           </>
//         );
//       }}
//     />
//   );
// };

export function isAuthenticate() {
  return !!Cookie.get(constants.TOKEN);
}

export function isRestrict(pathname, role) {
  return ROLE_TABLE[pathname] && ROLE_TABLE[pathname].indexOf(role) === -1;
}

const ROLE_TABLE = {
  '/home': [constants.Roles.ROLE_USER],
  '/admin': [constants.Roles.ROLE_ADMIN, constants.Roles.ROLE_MANAGER],
};
